import axios from 'axios';

axios.defaults.withCredentials = true;
import store from '@/store/store';
import qs from 'qs';
import storage from './storage';
import defaultData from "./defaultData";
import cookie from "./cookie";
import router from "../router";
import common from "../common/common"
import commons from "@/libsV2/common";
import {Toast} from 'mint-ui';

import oAes from './encryption';
import es from "element-ui/src/locale/lang/es";
import URLAPI from "./urlApi";
import {userContract} from "@/js/member/mynews/index.js";
import defalutData from "@/libsV2/defaultData";


// 是否开启加密模块
const isEncryption = false
var URL = URLAPI.URL
var URL5 = URLAPI.URL5
var weixinxcx = URLAPI.weixinxcx

const request = {
    initUrl: 'comm/index/init',
    shareUrl: 'wechat/api/getsign',
    tokenUrl: 'tools/token/get',  //获取token
    // defaultData: { // 接口默认的参数
    //     source: 'h5',
    //     user_id: '',
    //     session_id: '',
    //     token: '',
    //     ck_prefix: '', //cookie的前缀
    //     ck_path: '',
    //     ck_domain: '',
    //     is_wechat: 0, //是否为微信环境
    //     is_wx_auth: 0, //是否刚刚授权
    //     is_login: 0, //是否登录
    //     is_mob_vl: '', //是否有手机号，本项目废弃
    //     oauth_url: '', //授权地址
    //     inviteuid: '', //邀请人ID，本项目废弃
    //     is_bind: '', //是否绑定，本项目废弃
    //     is_wx_rela: 0, //是否已经关联微信记录
    //     callback_url: encodeURIComponent(window.location.href),
    // },
    defaultData: defaultData.defaultData,

    //统一使用storage.js;里面的方法
    // setStorage: function (key, value) { //  设置Storage    key:设置的名称。value：设置的内容
    //     if (key instanceof Object) {
    //         for (var k in key) {
    //             var curTime = new Date().getTime();
    //             localStorage.setItem(k, JSON.stringify({
    //                 data: key['' + k],
    //                 time: curTime
    //             }));
    //             if (this.defaultData.hasOwnProperty(k)) {
    //                 this.defaultData[k] = key['' + k];
    //             }
    //             this.defaultData[k] = key['' + k];
    //         }
    //         return;
    //     }
    //     var curTime = new Date().getTime();
    //     localStorage.setItem(key, JSON.stringify({
    //         data: value,
    //         time: curTime
    //     }));

    //     if (this.defaultData.hasOwnProperty(key)) {
    //         this.defaultData[key] = value;
    //     }
    //     return value;
    // },
    /**
     * 重新调用init接口
     */
    reStartInit() {
        storage.setStorage('session_id', '');
        this.getToken().then(res => {
            console.log('res', res)
            let inviteuid = common.getQueryString('inviteuid');
            // 判断是不是微信端
            if (res.is_wechat == 0) {
                // 跳转到报错页
                router.push({
                    path: '/wechat'
                });
            } else {
                // 判断用户登录
                if (res.is_login) {
                    // 判断授权登录
                    if (res.is_wx_auth) {
                        // if (inviteuid) {
                        //     router.push({
                        //         path: '/inviteuid?inviteuid=' + inviteuid,
                        //         replace: true
                        //     })
                        // } else {
                        //     // TODO:回到入口页
                        //     router.push({
                        //         path: '/antinfo/index',
                        //         replace: true
                        //     })
                        // }
                    } else {
                        // 判断没有没有这个字段 ： oauth_url
                        if (res.oauth_url) { // 如果有跳转到这个字段   oauth_url
                            // localStorage.removeItem('token');
                            storage.removeStorage('token');
                            window.location.href = res.oauth_url;
                        } else {
                            let inviteuid = common.getQueryString('inviteuid');
                            // 刷新缓存。如果有inviteuid。带上inviteuid
                            Toast({
                                message: "授权系统繁忙！",
                                duration: 1200
                            });
                        }
                    }
                } else {
                    if (res.is_wx_auth || res.is_wx_rela) {
                        return true;
                    }
                    // 判断没有没有这个字段 ： oauth_url
                    else if (res.oauth_url) { // 如果有跳转到这个字段   oauth_url
                        localStorage.clear();
                        window.location.href = res.oauth_url;
                        return;
                    } else {
                        Toast({
                            message: "返回值缺少授权地址;main:157",
                            duration: 1200
                        });
                    }
                }
            }
        });
    },
    getDefaultData() {
        //
        for (let item in this.defaultData) {
            // source的不做更改不然所有接口会有跨域问题
            if (item != 'source') {
                this.defaultData[item] = storage.getStorage(item);
            }
        }
        let inviteuid = storage.getStorage("inviteuid", 30); // 判断有没有超过30天
        this.defaultData.inviteuid = inviteuid ? inviteuid : "";
    },
    /**
     * 校验token是否过期 需要校验的接口需调用获取token，并在本地存入key值为接口地址的token字段。做校验用
     */
    checkToken(url) {
        let urlList = [];
        let a = urlList.find(it => {
            return it == url
        });
        return new Promise((resolve, reject) => {
            // 请求接口不在校验token列表内，直接返回true;
            if (!a) {
                resolve();
            } else {
                let objData = {
                    sid: cookie.getCookie('sid'),
                    source: 'h5',
                    callback: url
                }
                // console.log(cookie.getCookie('sid'))

                //加密模块
                let requestData, sToken
                if (isEncryption) {
                    sToken = oAes.productionToken(objData)
                    const encryptionData = {
                        data: encodeURI(oAes.Encrypt(JSON.stringify(objData))),
                        time: oAes.nowTime
                    }
                    requestData = qs.stringify(encryptionData)
                } else {
                    requestData = qs.stringify(objData)
                    sToken = null
                }

                axios.post(
                    URL5 + this.tokenUrl,
                    requestData,
                    // {
                    //     headers: {
                    //         'content-type': 'application/x-www-form-urlencoded', // 默认值
                    //         'sign': sToken,//加密需开启
                    //     },
                    // }
                ).then(res => {
                    if (res.data.error == 0) {
                        // 解密
                        if (isEncryption) {
                            res.data.data.result = oAes.Decrypt(res.data.data.result); //解密
                            res.data.data.result = JSON.parse(res.data.data.result);
                        }
                        let data = res.data.data.result.token;
                        sessionStorage.setItem(`${url}_TOKEN`, data);
                        resolve('isToken');
                    } else {
                        this.reportErr(this.tokenUrl, requestData, res.data)
                        Toast({
                            message: URL5 + this.initUrl,
                            duration: 500
                        });
                        this.checkPrefixData(res);
                    }
                });
            }
        })
    },
    /**
     * 获取token
     */
    getToken: function () {
        var token = storage.getStorage('token');
        var sessionId = storage.getStorage('session_id');
        var is_mob_vl = storage.getStorage('is_mob_vl');
        var checkCookie = this.checkCookieData();
        return new Promise((resolve, reject) => {
            if (token && sessionId && is_mob_vl !== false && checkCookie) {
                this.getDefaultData();
                resolve(this.defaultData);
            } else {
                let inviteuid = common.getQueryString('inviteuid')
                let objData = {
                    inviteuid: inviteuid,
                    source: 'h5',
                    // debug_skip_login: '1',
                    callback_url: encodeURIComponent(window.location.href)
                }
                //加密模块
                let requestData, sToken
                if (isEncryption) {
                    sToken = oAes.productionToken(objData)
                    const encryptionData = {
                        data: encodeURI(oAes.Encrypt(JSON.stringify(objData))),
                        time: oAes.nowTime
                    }
                    requestData = qs.stringify(encryptionData)
                } else {
                    requestData = qs.stringify(objData)
                    sToken = null
                }

                axios.post(
                    URL5 + this.initUrl,
                    requestData,
                    // {
                    //     headers: {
                    //         'content-type': 'application/x-www-form-urlencoded', // 默认值
                    //         'sign': sToken,//加密需开启
                    //     },
                    // }
                ).then(res => {
                    if (res.data.error == 0) {
                        // 解密
                        if (isEncryption) {
                            res.data.data.result = oAes.Decrypt(res.data.data.result); //解密
                            res.data.data.result = JSON.parse(res.data.data.result);
                        }

                        let data = res.data.data;
                        // console.log('getToken=====>', data);

                        // 保存默认数据
                        var obj = {
                            'session_id': data.result.session_id,
                            'token': data.token,
                            'is_login': data.result.is_login,
                            'ck_prefix': res.data.ck_prefix,
                            'ck_domain': data.result.ck_domain,
                            'ck_path': data.result.ck_path,
                            'is_wechat': data.result.is_wechat,
                            'is_mob_vl': data.result.is_mob_vl,
                            'oauth_url': data.result.oauth_url,
                            'user_id': data.result.user_id,
                            'is_wx_auth': data.result.is_wx_auth,
                        };

                        // this.setStorage(obj);
                        storage.setStorage(obj);
                        resolve(this.defaultData);
                    } else {
                        this.reportErr(this.initUrl, requestData, res.data)
                        Toast({
                            message: URL5 + this.initUrl,
                            duration: 500
                        });
                        this.checkPrefixData(res);
                    }
                    store.state.initError = false;
                }).catch(e => {
                    store.state.initError = true;
                    Toast({
                        // message: "getToken->系统错误！",
                        message: "getToken->系统错误！",
                        position: 'bottom',
                        duration: 1200
                    });
                })

            }
        })
    },

    /**
     * 接口初始化
     */
    ajaxData: function (url, data = {}, defaultData = this.defaultData) {
        return new Promise((resolve, reject) => {
            // 传过来的数据和默认数据合并
            let inviteuid = common.getQueryString('inviteuid');
            let formData = {
                inviteuid: inviteuid,
                source: 'h5',
                user_id: storage.getStorage('user_id'),
                // debug_skip_login: '1',
                callback_url: encodeURIComponent(window.location.href)
            }
            let obj = Object.assign({}, formData, data);
            this.checkToken(url).then(res => {
                if (res == 'isToken') obj.acctoken = sessionStorage.getItem(`${url}_TOKEN`);
                //加密模块
                let requestData, sToken
                if (isEncryption) {
                    sToken = oAes.productionToken(obj)
                    const encryptionData = {
                        data: encodeURI(oAes.Encrypt(JSON.stringify(obj))),
                        time: oAes.nowTime
                    }
                    requestData = qs.stringify(encryptionData)
                } else {
                    requestData = qs.stringify(obj)
                    sToken = null
                }

                axios.post(
                    URL5 + url,
                    requestData,
                    {
                        // headers: {
                        //     // 'content-type': 'application/x-www-form-urlencoded', // 默认值
                        //     // 'sign': sToken,//加密需开启
                        // },
                    }
                ).then(res => {
                    this.checkPrefixData(res);
                    // session_id 不等于本地数据 重新调用init接口
                    if (res.data.session_id != storage.getStorage('session_id')) {
                        // console.log("session_id不相等", res.data.session_id, storage.getStorage('session_id'))
                        // 重新调用init接口
                        this.reStartInit()
                        return false;
                    } else {
                        this.defaultData.token = res.data.data.token;
                        // 保存最新的token
                        storage.setStorage('token', this.defaultData.token);
                        if (res.data.error == -1) {
                            this.reportErr(url, requestData, res.data)
                            // Toast('用户未登录！')
                            this.reStartInit()
                            // reject(res);
                            // window.location.href = '/user/login';
                            // store.commit('loadSwitch');
                            store.commit('loadSkeleton', {bool: false});
                        } else if (res.data.error == 1) {
                            this.reportErr(url, requestData, res.data)
                            reject(res);
                            Toast(res.data.msg)
                            store.commit('loadSwitch');
                            store.commit('loadSkeleton', {bool: false});

                        } else if (res.data.error == 0) {
                            // 解密
                            if (isEncryption) {
                                res.data.data.result = oAes.Decrypt(res.data.data.result); //解密
                                res.data.data.result = JSON.parse(res.data.data.result);
                            }
                            resolve(res);
                        }
                    }
                }).catch(e => {
                    //接口出错2s后关闭loading
                    store.commit('loadSwitch');
                    // 发布之后 删除打印Url
                    Toast({
                        message: url,
                        position: 'bottom',
                        duration: 3000
                    });
                })
            });
        })
    },
    /**
     * ajax请求
     * @param [url] 接口地址。
     * @param [data] 发送参数。
     */
    getData: function (url, data = {}) {
        // init接口错误。 调用接口全部停止
        return this.getToken().then(res => {
            return this.ajaxData(url, data, res);
        })
    },
    /**
     * ajax请求JSON
     * @param [url] JSON地址。
     */
    getDataJson: function (url) {
        return new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest()
            xhr.open('GET', url, true)
            xhr.onload = function (e) {
                if (this.status == 200) {
                    resolve({
                        data: JSON.parse(e.currentTarget.responseText)
                    })
                } else {
                    reject()
                }
            }
            xhr.send()
        })
    },
    ambient() {
        return new Promise((resolve, reject) => {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                if (ua.match(/WxWork/i) == "wxwork") {
                    if (wx?.miniProgram?.getEnv) {
                        wx.miniProgram.getEnv(function (res) {
                            if (res.miniprogram) {
                                // 小程序环境下逻辑
                                resolve(1);
                            } else {
                                //非小程序环境下逻辑
                                resolve(2);
                            }
                        });
                    } else {
                        //企业微信环境下
                        resolve(2);
                    }
                } else {
                    //判断是否是微信环境
                    //微信环境
                    wx.miniProgram.getEnv(function (res) {
                        if (res.miniprogram) {
                            // 小程序环境下逻辑
                            resolve(1);
                        } else {
                            //非小程序环境下逻辑
                            resolve(3);

                        }
                    });
                }
            } else {
                // 非微信环境逻辑
                resolve(2);
            }
        });
    },
    // 校验用户是否绑定手机号码，用于用户在线c端 （仅微信环境）
    memberInfo: function (data = {}) {
        let _that = this
        return new Promise((resolve, recject) => {
            // if (router.app.$route.query.sampleroom) {
            //     storage.setStorage('sampleroom_info', router.app.$route.query);
            // }
            // if (!router.app.$route.query.remove && !router.app.$route.query.sampleroom) {
            //     storage.removeStorage('sampleroom_info');
            // }
            if (router.app.$route.query.sampleroom) {
                let objData = router.app.$route.query
                resolve(objData);
            } else {
                request.getData('member/access/check', data).then(res => {
                    // store.commit("loadSkeleton", {bool: false, type: "home"});
                    if (res.data.error == 0) {
                        if (res.data.data.result.is_need_to_auth_phone) {
                            router.push({
                                path: `/member/common/business`,
                                query: {shareId: router.app.$route.query.shareId || ''},
                                replace: true
                            })
                        } else {
                            let contractid = router.app.$route.query.contractid || router.app.$route.query.contractId || router.app.$route.query.contract_id
                            let projectUuid = router.app.$route.query.project_uuid || router.app.$route.query.projectmgnid
                            if(contractid && !router.app.$route.query.sampleroom && commons.isWechat() != defalutData.weChat.wxWork){
                                // 交付报告客户打开的链接需要验证,微信环境
                                userContract({contractid}).then(res=>{
                                    console.log(88877)
                                    let objData = router.app.$route.query
                                    resolve(objData);
                                }).catch(err=>{
                                    console.log(err,'报错')
                                    let msg = err.data.msg
                                    let type=1
                                    if(msg.indexOf("用户合同未绑定")!=-1 || msg.indexOf("用户无合同记录")!=-1 || msg.indexOf("暂未查询到项目交付档案")!=-1){
                                        type=2
                                    }
                                    router.push({
                                        path: `/member/v2/contract/error?type=${type}&shareId=${router.app.$route.query.shareId}&project_uuid=${projectUuid}`,
                                    })
                                    // recject()
                                })
                            }else{
                                let objData = router.app.$route.query
                                resolve(objData);
                            }
                        }
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 1200
                        });
                        recject();
                        throw 0;
                    }
                }).catch(err => {
                    // store.commit('loadAutorty',true);
                    router.push({
                        path: `/member/common/business`,
                        query: {shareId: router.app.$route.query.shareId || ''},
                        replace: true
                    })
                    store.commit("loadSkeleton", {bool: false, type: "home"});
                    if (err.data.error == 1) {
                        Toast({
                            message: err.data.msg,
                            duration: 1200
                        });
                        recject();
                    }
                })
            }
        })
    },
    // 校验用户是否绑定手机号码，用于用户在线-设计师 （仅微信环境）
    designerInfo: function (data = {}) {
        let _that = this;
        return new Promise((resolve, recject) => {
            if (router.app.$route.query.sampleroom) {
                request.getData('design/index/getphone', {
                    contract_id: router.app.$route.query.new_contract_id
                }).then((res) => {
                    if (res.data.error == 0) {
                        storage.setStorage('design_phone', res.data.data.result.phone);
                        resolve(res.data.data.result);
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 1200
                        });
                        recject();
                        throw 0;
                    }

                }).catch((err) => {
                    if (err.data.error == 1) {
                        Toast({
                            message: err.data.msg,
                            duration: 1200
                        });
                        recject();
                    }
                })
            } else {
                request.getData('design/index/check', data).then(res => {
                    if (res.data.error == 0) {
                        if (res.data.data.result.is_need_to_auth_phone) {
                            router.replace({
                                path: `/designer/xcx/business`,
                                query: {
                                    url: `${window.location.href}`
                                }
                            })
                        } else {
                            storage.setStorage('design_phone', res.data.data.result.phone);
                            resolve(res.data.data.result);
                        }
                    } else {
                        Toast({
                            message: res.data.msg,
                            duration: 1200
                        });
                        recject();
                        throw 0;
                    }
                }).catch(err => {
                    // store.commit('loadAutorty',true);
                    router.replace({
                        path: `/designer/xcx/business`,
                        query: {
                            shareId: router.app.$route.query.shareId || '',
                            url: `${window.location.protocol}//${window.location.host}/designer/index/index`
                        }
                    })
                    store.commit("loadSkeleton", {bool: false});
                    if (err.data.error == 1) {
                        Toast({
                            message: err.data.msg,
                            duration: 1200
                        });
                        recject();
                    }
                })
            }
        })
    },
    /**
     * cookie判断
     */
    checkCookieData: function (res) {
        let sid = cookie.getCookie('sid');
        // return true;
        // let bbcode = cookie.getCookie('bbcode');
        if (sid == '') {
            // alert(localStorage.length);
            localStorage.clear();
            // cookie.deleteAllCookie();
            return false;
        } else {
            return true;
        }
    },
    /**
     * 判断ck_prefix 是否相等
     */
    checkPrefixData: function (res) {
        let ck_prefix = res.data.ck_prefix;
        if (ck_prefix != this.defaultData.ck_prefix) {
            var arr = ['session_id', 'token', 'is_login', 'ck_prefix', 'ck_path', 'ck_domain', 'is_wechat', 'is_mob_vl', 'oauth_url', 'user_id'];
            storage.removeStorage(arr);
            cookie.deleteAllCookie();
        }
    },
    singleAjaxData: function (url, data = {}, defaultData = this.defaultData) {
        return new Promise((resolve, reject) => {
            // 传过来的数据和默认数据合并
            let formData = {
                source: data.app ? 'app' : 'h5',
                token: this.defaultData.token,
                callback_url: encodeURIComponent(window.location.href)
            }
            let obj = Object.assign({}, formData, data);
            // delete obj.user_id;

            //加密模块
            let requestData, sToken
            if (isEncryption) {
                sToken = oAes.productionToken(obj)
                const encryptionData = {
                    data: encodeURI(oAes.Encrypt(JSON.stringify(obj))),
                    time: oAes.nowTime
                }
                requestData = qs.stringify(encryptionData)
            } else {
                requestData = qs.stringify(obj)
                sToken = null
            }

            axios.post(
                URL5 + url,
                requestData,
                // {
                //     headers: {
                //         'content-type': 'application/x-www-form-urlencoded', // 默认值
                //         'sign': sToken,//加密需开启
                //     },
                // }
            ).then(res => {
                // 解密
                if (isEncryption) {
                    res.data.data.result = oAes.Decrypt(res.data.data.result); //解密
                    res.data.data.result = JSON.parse(res.data.data.result);
                }
                if (res.data.error != 0) {
                    this.reportErr(url, requestData, res.data)
                }
                resolve(res);
            }).catch(e => {

            })
        })
    },

    /**
     * 接口错误上报
     * @param url
     * @param params
     * @param res
     */
    reportErr: (url, params, res) => {
        if (window.location.host != 'aosmithv2.iwxapi.com') {
            return
        }
        let oParams = ''
        if (typeof params == 'string') {
            let arr = params.split('&')
            let obj = {}
            arr.map(item => {
                obj[item.split('=')[0]] = item.split('=')[1] || ''
            })
            oParams = JSON.stringify(obj)
        } else if (typeof params == 'object') {
            oParams = JSON.stringify(params)
        }
        let storageObj = {};
        for (let i in window.localStorage) {
            if (i.indexOf(storage.STORAGE_PRE) > -1) {
                storageObj[i] = encodeURIComponent(window.localStorage[i])
            }
        }
        let param = "&type=0";
        param += "&url=" + encodeURIComponent(window.location.href);
        param += "&host=" + window.location.host;
        param += "&request_url=" + url;
        param += "&query=" + oParams;
        param += "&api_error=" + JSON.stringify(res.error || {});
        param += "&data=" + JSON.stringify(res || {});
        param += "&storage=" + JSON.stringify(storageObj);
        param += "&cookie=" + document.cookie;
        let errURL = "https://web-error.cn-beijing.log.aliyuncs.com/logstores/aosmith-h5/track_ua.gif?APIVersion=0.6.0" + param;
        let logstores = new Image()
        logstores.src = errURL;
        logstores = null
    },
}


export default request;
